import { render, staticRenderFns } from "./PeriodicityRegister.vue?vue&type=template&id=102c7190"
import script from "./PeriodicityRegister.vue?vue&type=script&lang=js"
export * from "./PeriodicityRegister.vue?vue&type=script&lang=js"
import style0 from "./PeriodicityRegister.vue?vue&type=style&index=0&id=102c7190&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports